// extracted by mini-css-extract-plugin
module.exports = {"social":"SocialShare_social__2nPaD"};